import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const conversionUtcDate = (date, type, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (type === 'local') {
    // 毫秒时间戳是绝对时刻：按本地时区展示（中国即 UTC+8）
    return dayjs.utc(date).local().format(format)
  } else if (type === 'UTC') {
    // 历史误用：对已是本地含义的 dayjs(date) 再 add(timezoneOffset)，
    // 在 UTC+8 会多加 8 小时（15:47 → 23:47）。毫秒戳应直接按本地格式化。
    return dayjs(date).format(format)
  }
}

export default conversionUtcDate
